import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import { SimpleModal } from '../../components/simple-modal';
import { messages } from './messages';

type SerialWarningModalProps = {
  onCancel: () => void;
  onProceed: () => void;
};

// Dismissable warning shown at print time under the Warn enforcement level.
// onCancel keeps the print blocked so the packer can go back and enter the
// serial; onProceed lets the print continue without it (Warn never hard-blocks).
export const SerialWarningModal = ({ onCancel, onProceed }: SerialWarningModalProps) => (
  <SimpleModal
    actionMessage={messages.warningModalProceed}
    cancelMessage={messages.warningModalCancel}
    headerMessage={messages.warningModalTitle}
    onAction={onProceed}
    onCancel={onCancel}
    onClose={onCancel}
  >
    <Text textType={TextType.Paragraph} value={messages.warningModalBody} />
  </SimpleModal>
);
